import type { LucideIcon } from 'lucide-react';
import {
  AudioLines,
  FileText,
  HelpCircle,
  MessageSquareText,
  ShieldCheck,
  SlidersHorizontal,
  Sparkles,
  User
} from 'lucide-react';

import type { UserSidebarSection } from '@/state/project';

export const SECTION_WIDGET_IDS: Record<UserSidebarSection, string[]> = {
  account: [],
  response: ['query_selection', 'prompt', 'temperature'],
  features: [
    'RAG',
    'Personal_RAG',
    'OSINT_RAG',
    'LTM',
    'WEB_SEARCH',
    'AUTO_RED',
    'GRAPH',
    'DOCS'
  ],
  prompts: [],
  docs: [],
  voice: ['audio_energy_threshold', 'audio_silence_duration_threshold'],
  help: [],
  admin: []
};

export type SectionMeta = {
  id: UserSidebarSection;
  label: string;
  icon: LucideIcon;
  blurb: string;
  disabled?: boolean;
};

export const SECTION_META: SectionMeta[] = [
  {
    id: 'account',
    label: 'Account',
    icon: User,
    blurb: 'Signed-in profile and session actions.'
  },
  {
    id: 'response',
    label: 'Response',
    icon: Sparkles,
    blurb: 'How the assistant answers you.'
  },
  {
    id: 'features',
    label: 'Features',
    icon: SlidersHorizontal,
    blurb: 'Knowledge sources and mode toggles.'
  },
  {
    id: 'prompts',
    label: 'Custom Prompts',
    icon: MessageSquareText,
    blurb: 'Reusable prompt templates the LLM will follow.'
  },
  {
    id: 'docs',
    label: 'User Docs',
    icon: FileText,
    blurb: 'Documents you have uploaded to the knowledge base.',
    disabled: true
  },
  {
    id: 'voice',
    label: 'Voice',
    icon: AudioLines,
    blurb: 'Audio input sensitivity.'
  },
  {
    id: 'help',
    label: 'Help',
    icon: HelpCircle,
    blurb: 'Privacy policy and support.'
  },
  {
    id: 'admin',
    label: 'Admin',
    icon: ShieldCheck,
    blurb: 'User access management. Admins only.'
  }
];
